import { render } from "./ModalOrderHistory.vue?vue&type=template&id=2732a775&scoped=true"
import script from "./ModalOrderHistory.vue?vue&type=script&lang=js"
export * from "./ModalOrderHistory.vue?vue&type=script&lang=js"

import "./ModalOrderHistory.vue?vue&type=style&index=0&id=2732a775&scoped=true&lang=css"

import exportComponent from "/Users/fabiankala/Documents/projects/jan-art/jan-art-system/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2732a775"]])

export default __exports__